import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Move focus to main content for screen reader users
    const main = document.getElementById('main-content');
    if (main) {
      // Temporarily set tabindex to ensure focus and then keep it (Layout sets -1)
      (main as HTMLElement).focus();
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
